import React from "react";
import { ColearnIconsId } from "design-system/foundation/icon-font/colearn-icons";

interface IconProps {
  name: ColearnIconsId;
}

export const Icon: React.FC<IconProps> = ({ name }) => {
  return <span className={`icon icon-${name}`} />;
};
